import { useEffect, useState } from 'react'
import { IUser } from '~/@api/generated-api-types/global.types'
import { useLoggedInUser } from '../useLoggedInUser/useLoggedInUser'

export const useCurrentUserData = () => {
  const { checkLoggedInUser } = useLoggedInUser()

  const [user, setUser] = useState<IUser | null>(null)

  const reloadUser = async () => {
    const response = await checkLoggedInUser()

    if (response?.user) {
      setUser(response.user)
    }
  }

  useEffect(() => {
    reloadUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { user, reloadUser }
}
